const cardQuantityActionTypes = {
  INIT_QUANTITY: "INIT_QUANTITY",
  INCREASE_QUANTITY: "INCREASE_QUANTITY",
  DECREASE_QUANTITY: "DECREASE_QUANTITY",
  SET_QUANTITY: "SET_QUANTITY",
  CLEAR_QUANTITY: "CLEAR_QUANTITY",
};

export default cardQuantityActionTypes;
